import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const ConversationMessageChatContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1 0;
    height: 100%;
    @media ${breakpoints.xs} {
        width: 100%;
        padding-left: 0;
    }
    > * {
        flex: 0 0 auto;
        overflow: scroll;
    }
    form {
        overflow: auto;
    }
    .archive {
        padding: 2px 4px;
        margin-left: 8px;
        font-size: var(--size-12);
        font-weight: bold;
        line-height: 18px;
        color: var(--color-tertiary-fg);
        background-color: var(--color-tertiary);
        border-radius: var(--radius-5);
    }
    .readonly {
        padding: 2px 4px;
        font-size: var(--size-12);
        font-weight: bold;
        line-height: 18px;
        color: var(--color-white);
        background-color: var(--color-info);
        border-radius: var(--radius-5);
    }
    .chat-header {
        display: flex;
        align-items: center;
        min-height: 66px;
        padding-left: 32px;
        overflow: hidden;
        border-bottom: 1px solid var(--color-grey-700);
        @media ${breakpoints.xs} {
            padding-left: 0;
            padding-top: 5px;
        }
    }
    .chat-header-title-container {
        display: flex;
        flex-direction: column;
    }
    .chat-header-action-icons {
        margin-right: 8px;
        @media ${breakpoints.xs} {
            margin-left: 8px;
        }
        svg {
            width: 24px;
            cursor: pointer;
        }
    }
    .chat-title {
        font-size: var(--size-18);
        font-weight: bold;
        line-height: 27px;
        color: var(--color-secondary);
        @media ${breakpoints.xs} {
            font-size: var(--size-16);
            line-height: 24px;
        }
    }
    .chat-subject-label {
        font-size: var(--size-16);
        line-height: 24px;
        color: var(--color-grey-900);
        @media ${breakpoints.xs} {
            font-size: var(--size-14);
            line-height: 24px;
        }
    }
    .conversation-chat-container {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        padding-left: 32px;
        margin-top: 25px;
        margin-bottom: 8px;
        overflow-x: hidden;
        overflow-y: auto;
        @media ${breakpoints.xs} {
            padding: 0 15px;
        }
        .message-timestamp {
            margin-top: 16px;
            font-size: var(--size-12);
            font-weight: normal;
            line-height: 18px;
            color: var(--color-grey-800);
        }
        .message {
            position: relative;
            min-width: 55%;
            max-width: 470px;
            padding: 8px 16px;
            .conversation-message {
                font-size: var(--size-14);
                line-height: 24px;
                color: var(--color-grey-900);
                word-break: break-word;
                p {
                    margin: 0;
                }
            }
            .status-icon {
                position: absolute;
                right: 8px;
                bottom: 8px;
                display: none;
            }
        }
        .message-out {
            align-items: flex-end;
            .message {
                background-color: var(--color-selected);
                border-radius: 10px 10px 0 10px;
            }
            .conversation-message-title {
                color: var(--color-secondary);
            }
        }
        .message-in {
            .message {
                background-color: var(--color-secondary-light);
                border-radius: 10px 10px 10px 0;
            }
            .conversation-message-title {
                color: var(--color-primary);
            }
        }
        .message-out,
        .message-in {
            display: flex;
            flex-direction: column;
            .conversation-message-title {
                font-size: var(--size-14);
                font-weight: bold;
                line-height: 24px;
            }
            &.isArchived {
                .message {
                    .status-icon {
                        display: none;
                    }
                }
                &.message-out {
                    .conversation-message-title {
                        color: var(--color-grey-800);
                    }
                    .message {
                        background-color: #f6f6f6;
                    }
                }
                &.message-in {
                    .conversation-message-title {
                        color: var(--color-grey-900);
                    }
                    .message {
                        background-color: var(--color-grey-700);
                    }
                }
            }
        }
    }
`;

export const ConversationProgressContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
`;

export const ConversationInfoBottomMessage = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    text-align: center;
    hr {
        box-sizing: content-box;
        flex: 1;
        height: 0;
        margin-right: 16px;
        margin-left: 16px;
        overflow: visible;
        border: 0;
        border-top: 1px solid var(--color-grey-700);
    }
    span {
        font-size: var(--size-14);
        color: var(--color-grey-800);
    }
`;
